interface JobsStorageOptions {
  nameSpace?: string;
  storage?: Storage;
}

export const DEFAULT_NAMESPACE = 'XING::Jobs';

export const hasLocalStorage = typeof window !== 'undefined' && window.localStorage;

export const noStorage: Pick<Storage, 'getItem' | 'setItem' | 'removeItem'> = {
  getItem: () => null,
  setItem: () => {},
  removeItem: () => {},
};

const getStorage = (options?: JobsStorageOptions): Pick<Storage, 'getItem' | 'setItem' | 'removeItem'> =>
  (options && options.storage) || (hasLocalStorage && localStorage) || noStorage;

const getNameSpace = ({ nameSpace }: JobsStorageOptions = {}): string =>
  nameSpace === undefined ? `${DEFAULT_NAMESPACE}.` : nameSpace;

export const getKey = <T = unknown>(key: string, defaultValue: T, options?: JobsStorageOptions): T => {
  let parsedData = null;
  try {
    parsedData = JSON.parse(getStorage(options).getItem(`${getNameSpace(options)}${key}`) || 'null');
    // eslint-disable-next-line no-empty
  } catch (e) {}

  return parsedData || defaultValue;
};

export const setKey = <T = unknown>(key: string, value: T, options?: JobsStorageOptions): void => {
  try {
    getStorage(options).setItem(`${getNameSpace(options)}${key}`, JSON.stringify(value));
  } catch (e) {
    // Catches QuotaExceededError. Same behaviour as noStorage
  }
};

export const removeKey = (key: string, options?: JobsStorageOptions): void =>
  getStorage(options).removeItem(`${getNameSpace(options)}${key}`);
